import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/components/landing/AuthContext";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { UseCases } from "@/components/landing/UseCases";
import { Specs } from "@/components/landing/Specs";
import { Reviews } from "@/components/landing/Reviews";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { StickyBuyBar } from "@/components/landing/StickyBuyBar";
import { Bundles } from "@/components/landing/Bundles";
import { buyNow } from "@/components/landing/shared";
import ThankYou from "@/components/landing/ThankYou";
import Checkout from "@/components/landing/Checkout";
import OrderSuccess from "@/components/landing/OrderSuccess";
import AuthPage from "@/components/landing/AuthPage";
import Account from "@/components/landing/Account";
import Admin from "@/components/landing/Admin";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Nav onBuy={buyNow} />
      <main>
        <Hero onBuy={buyNow} />
        <Marquee />
        <Manifesto />
        <UseCases />
        <Specs />
        <Bundles />
        <Reviews />
        <FAQ />
        <FinalCTA onBuy={buyNow} />
      </main>
      <StickyBuyBar onBuy={buyNow} />
    </>
  );
};

function App() {
  return (
    <div className="App bg-ink text-foreground font-body" data-testid="x8-landing-page">
      <div className="noise-overlay" aria-hidden="true" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
